import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/overstockInventory'
import Component from 'components/OverstockInventory'

export default createListViewContainer({ actions, selectors: selectors.overstockInventory })(Component)
